import { Index } from './index';

export default {

    index() {
        document.addEventListener('DOMContentLoaded', () => {
            new Index().Run();
        }, false);
    }

}
